import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('csform_token');
        const data = localStorage.getItem('csform_admin');
        if (token && data) {
            try { setAdmin(JSON.parse(data)); } catch { localStorage.clear(); }
        }
        setLoading(false);
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post('/auth/login', { email, password });
        localStorage.setItem('csform_token', data.token);
        localStorage.setItem('csform_admin', JSON.stringify(data.admin));
        setAdmin(data.admin);
        return data;
    };

    const logout = () => {
        localStorage.removeItem('csform_token');
        localStorage.removeItem('csform_admin');
        setAdmin(null);
    };

    return (
        <AuthContext.Provider value={{ admin, login, logout, loading, estConnecte: !!admin }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);